import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MyDatePickerModule } from 'mydatepicker';
import { OigComponent } from './oig.component';
import { OigRoutingModule } from './oig-routing.module';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { getOigHTTPService } from './oig-dataService';
import { OigService } from './oig.service';

@NgModule({
  declarations: [OigComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    GridModule,
    MyDatePickerModule,
    NgxChartsModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    OigRoutingModule,
    PDFExportModule
  ],
  providers: [getOigHTTPService, ColumnChooserService, FilterService, PageService, ResizeService, OigService]
})
export class OigModule { }
